import {
    Button,
    Checkbox,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TextField,
} from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getLoyaltyConfigItems,
    updateConfigValue,
    updateLoyaltyConfigItems,
} from '../../../store/actions/loyaltyConfigActions';
import SideNav from '../../common/SideNav';
import { Box } from '@mui/system';
import { Link } from 'react-router-dom';

const LoyaltyConfig = () => {
    const dispatch = useDispatch();
    const { loyaltyConfigItems } = useSelector((state) => state.loyaltyConfig);

    useEffect(() => {
        dispatch(getLoyaltyConfigItems());
    }, []);

    const handleValueChange = (id, field, value) => {
        dispatch(updateConfigValue(id, field, value));
    };

    const handleSave = () => {
        const payload = loyaltyConfigItems.map((config) => {
            return {
                loyaltyConfigId: config.loyaltyConfigId,
                value:
                    config.type === 'I'
                        ? config.valueNum.toString()
                        : config.valueStr,
                status: config.status,
                description: config.description,
            };
        });

        dispatch(updateLoyaltyConfigItems(payload));
    };

    return (
        <div>
            <div className="component-container-root">
                <SideNav />
                <Box className="manage-events-container component-container">
                    <p className="instruction">
                        View and manage the Loyalty Program Configuration. Go to
                        '<Link to="/help">Help page</Link>' for information on
                        how to manage.
                    </p>
                    <Box sx={{ p: 3 }}>
                        <>
                            <TableContainer component={Paper}>
                                <Table exportButton={true}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>ID</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Domain</TableCell>
                                            <TableCell>Key</TableCell>
                                            <TableCell>Value</TableCell>
                                            <TableCell>Description</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {loyaltyConfigItems.map((config) => (
                                            <TableRow
                                                key={config.loyaltyConfigId}
                                            >
                                                <TableCell>
                                                    {config.loyaltyConfigId}
                                                </TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={config.status}
                                                        onChange={() =>
                                                            handleValueChange(
                                                                config.loyaltyConfigId,
                                                                'status',
                                                                !config.status
                                                            )
                                                        }
                                                        sx={(theme) => ({
                                                            color: theme.palette
                                                                .primary.main,
                                                            '&.Mui-checked': {
                                                                color: theme
                                                                    .palette
                                                                    .primary
                                                                    .main,
                                                            },
                                                        })}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    {config.domain}
                                                </TableCell>
                                                <TableCell>
                                                    {config.key}
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        variant="outlined"
                                                        size="small"
                                                        value={
                                                            config.type === 'I'
                                                                ? config.valueNum
                                                                : config.valueStr
                                                        }
                                                        onChange={(e) =>
                                                            handleValueChange(
                                                                config.loyaltyConfigId,
                                                                config.type ===
                                                                    'I'
                                                                    ? 'valueNum'
                                                                    : 'valueStr',
                                                                e.target.value
                                                            )
                                                        }
                                                        fullWidth
                                                        type={
                                                            config.type === 'I'
                                                                ? 'number'
                                                                : 'text'
                                                        }
                                                        disabled={
                                                            !config.status
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <TextField
                                                        variant="standard"
                                                        size="small"
                                                        value={
                                                            config.description
                                                        }
                                                        onChange={(e) =>
                                                            handleValueChange(
                                                                config.loyaltyConfigId,
                                                                'description',
                                                                e.target.value
                                                            )
                                                        }
                                                        fullWidth
                                                        type="text"
                                                        disabled={
                                                            !config.status
                                                        }
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleSave}
                                sx={{ mt: 2 }}
                            >
                                Save Changes
                            </Button>
                        </>
                    </Box>
                </Box>
            </div>
        </div>
    );
};

export default LoyaltyConfig;
